import { Trans } from '@lingui/macro'
import { Typography } from '@mui/material'
import type { EnhancedDomain } from 'sunlife-domain'

import { LocalizableMessage, MaterialSwatchSelector } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

export const DrawStringProperties = (props: { entity: EnhancedDomain.$Drawstring }) => {
  const { entity } = props
  return (
    <PropertyContainer.Group spacing="large">
      <PropertyContainer.Item
        title={
          <Typography>
            <Trans>Color</Trans>
          </Typography>
        }
        action={
          <Typography variant="body2">
            <LocalizableMessage>{entity.$selectedColor.name}</LocalizableMessage>
          </Typography>
        }
      >
        <MaterialSwatchSelector entityId={entity.id} instanceName="color" />
      </PropertyContainer.Item>
    </PropertyContainer.Group>
  )
}
